import React,{useState} from 'react'; 
import './heading.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars,faChevronDown} from '@fortawesome/free-solid-svg-icons'; 
import Logo from '../images/logo.png';
import ContactHeading from './contact-heading'; 



function Heading() {
 
    const [ToggleEffect, setToggleEffect] = useState(false);

    const [isExpand , setIsExpand ] = useState(false)
  
    const [DropdownToggle, setDropdownToggle] = useState(false);

    const ToggleHandler = () => {
           setToggleEffect(!ToggleEffect);
    }
     

    return (<>
        <ContactHeading  />
        <div className="heading"> 
                
            <div className='heading_logo'> 
             <div>
              <img  src={Logo} alt="Logo" className='logo_icon'  onClick={()=> window.open("/","_self")}/>
             </div>
    
              <div>
                  <div className='logo_title'>Land Promoters &#38;</div>
                  <div className='logo_subtitle'>Construction company</div>
              </div>
            </div>
            <div className="navbar_desktop">
         <nav className='navbar navbar-expand ' >
          <ul className='navbar-nav'>
            <li className='nav-item'>
              <a href="/" className='nav-link'>Home</a>
            </li>
            
            <li className='nav-item'>
              <a href="/about-us" className='nav-link'>About us</a>
            </li>
            
            <li className='nav-item'>
                <div className='service_dropdown_container' >
                  <button className='service_dropdown_button' onClick={()=>{setDropdownToggle(!DropdownToggle)}}>Service
                  <FontAwesomeIcon icon={faChevronDown} className="faChevronDown"/>
                  </button>
                  <div className='service_dropdown_content' style={DropdownToggle ? {display:'flex'} : {display:'none'}} >
                          <a className='service_dropdown_link' href="/service-plots">Plots and Approvals</a>
                          <a className='service_dropdown_link' href='/service-construction'>Construction Work</a> 
                          
                          <a className='service_dropdown_link' href='/service-roadwork'>Road Work</a> 
                  </div>
                </div>
             </li>
    
            <li className='nav-item'>
              <a href="/gallery" className='nav-link'>Gallery</a>
            </li>
            
            <li className='nav-item'>
              <a href="/contact-us" className='nav-link'>contact us</a>
            </li>
          </ul>
         </nav>
         </div>

          <FontAwesomeIcon icon={faBars} className='bar_icon' onClick={ToggleHandler}/>
       <div  className="navbar_mobile" style={ToggleEffect ? {display:'block',zIndex:'10'} : {display:'none'}}>
       <nav>
          <div className="x_bar" style={ToggleEffect ? {display:'block',color:'black'} : {display:'none'}} onClick={ToggleHandler}>X</div>
          <ul className='navbar-nav'>
            <li className='nav-item'>
              <a href="/" className='nav-link' onClick={ToggleHandler}>Home</a>
            </li>
            
            <li className='nav-item'>
              <a href="/about-us" className='nav-link' onClick={ToggleHandler}>About us</a>
            </li>
            
            <li className='nav-item'>
              <div onClick={()=> setIsExpand(!isExpand)} className="mobile_service_expand">Service</div>
            <div style={!isExpand ? {display:'none'} : {textDecoration:'none',color:'black'}}>
              <a href='service-plots' className='nav-link mobile_service_link' >Plots and Approvals</a>
              <a href='service-construction' className='nav-link mobile_service_link'  style={{textDecoration:'none'}}>Construction</a>
              <a href='service-roadwork' className='nav-link mobile_service_link'  style={{textDecoration:'none'}}>Road Work</a>
            </div>
            </li>
            
            <li className='nav-item'>
              <a href="/gallery" className='nav-link' onClick={ToggleHandler}>Gallery</a>
            </li>
            
            <li className='nav-item'>
              <a href="/contact-us" className='nav-link' onClick={ToggleHandler}>contact us</a>
            </li>
          </ul>
         </nav>
          
       </div>

        </div>
        </>
    )
}

export default Heading
